import { Heart } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Rsvp({ datos, seccion, acciones }) {
  const rsvp = datos.rsvp || {};

  return (
    <section className="we-seccion we-rsvp" aria-label={seccion.titulo}>
      <div className="we-seccion-interior">
        <EncabezadoSeccion
          etiqueta={seccion.etiqueta}
          titulo={seccion.titulo}
          centro
          testid="we-titulo-rsvp"
        />
        <Reveal delay={0.1}>
          {rsvp.mensaje && <p className="we-rsvp-mensaje">{rsvp.mensaje}</p>}
          {rsvp.fechaLimite && <p className="we-rsvp-limite">{rsvp.fechaLimite}</p>}
          <button
            type="button"
            className="we-boton we-boton--claro"
            onClick={() => acciones?.onConfirmarAsistencia?.()}
            data-testid="we-boton-rsvp"
          >
            <Heart strokeWidth={1.5} />
            {rsvp.textoBoton || "Confirmar asistencia"}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
